export const clamp = (value: number, min: number, max: number): number =>
  value < min ? min : value > max ? max : value;

/**
 * Lissage exponentiel indépendant du framerate.
 * Un lerp à coefficient fixe converge deux fois plus vite à 120 fps qu'à 60 ;
 * cette forme donne le même résultat quel que soit dt.
 */
export const damp = (
  current: number,
  target: number,
  lambda: number,
  dt: number,
): number => target + (current - target) * Math.exp(-lambda * dt);
